import { css } from '@emotion/css';
import { colors } from '@ajaibid/components';

export const styPopupContainer = css`
  > .modal-content {
    min-width: 660px; /* OrderBook: 320px, StockAmend: 320px, padding: 4x4px, gap: 4px */
    background: transparent;

    > * {
      padding: 0;
      text-align: left !important;
    }
  }
`;

export const styPopupInner = css`
  background: ${colors.NEUTRAL_0};
  padding: 4px;
  border-radius: 8px;

  height: 90vh;
  overflow-y: scroll;
`;

export const styStockAmendContainer = css`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;

  > * {
    min-width: 270px;
  }
`;

export const styBodyContainer = css`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  overflow-y: scroll;
  overflow-x: visible;
`;
